module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/sec07_sp_6b5a33c9fc65d5785232d1aadff2c219.jpg";